import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const CallingMadeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "CallingMade",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M2.83 15.62c.14.39.31.78.51 1.18 1.23 2.5 2.8 4.64 4.67 6.46 1.83 1.87 3.97 3.42 6.33 4.58l.14.06c.72.35 1.57.68 2.45.92l.11.03c2.66.72 5.05.44 6.5-1.02l1.35-1.37c.36-.35.57-.84.57-1.38s-.22-1.03-.57-1.38l-3.67-3.64c-.35-.35-.83-.57-1.37-.57s-1.02.22-1.37.57l-2.66 2.66c-.23.23-.56.38-.91.38s-.68-.14-.91-.38l-5.51-5.46c-.24-.23-.38-.56-.38-.91s.15-.68.38-.91l2.66-2.66c.35-.35.57-.83.57-1.37s-.22-1.02-.57-1.37L7.52 6.36c-.35-.35-.83-.57-1.37-.57s-1.02.22-1.37.57L3.41 7.72c-1.71 1.71-1.8 4.66-.58 7.9M28.18 3.08l-7.24 7.24-2.98-2.98c-.19-.19-.46-.31-.76-.31-.59 0-1.07.48-1.07 1.07 0 .29.12.56.31.76l3.73 3.73a1.09 1.09 0 0 0 1.52 0l7.99-7.99a1.09 1.09 0 0 0 0-1.52 1.09 1.09 0 0 0-1.52 0Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M21.13 29.29c-2.18 0-4.23-.85-5.77-2.39L4.25 15.78A8.12 8.12 0 0 1 2.8 6.22a1.14 1.14 0 1 1 2.02 1.06 5.84 5.84 0 0 0 1.05 6.88l11.12 11.12C18.1 26.39 19.57 27 21.14 27s3.04-.61 4.15-1.72l1.25-1.25-4.26-4.26a3.47 3.47 0 0 1-4.8-.12l-6.01-6.01a3.45 3.45 0 0 1-1.02-2.46c0-.87.32-1.69.9-2.33L6.3 3.81c-.45-.45-.45-1.17 0-1.62s1.17-.45 1.62 0l5.84 5.85c.45.45.45 1.17 0 1.62l-.68.68c-.23.23-.35.53-.35.84s.12.62.35.84l6.01 6.01c.45.45 1.18.47 1.65.04l.79-.73c.45-.41 1.15-.4 1.58.04l5.84 5.84a1.16 1.16 0 0 1 0 1.62l-2.05 2.05a8.1 8.1 0 0 1-5.77 2.39ZM23.19 10.24c-.3 0-.59-.12-.81-.33l-3.05-3.05c-.45-.45-.45-1.17 0-1.62s1.17-.45 1.62 0l2.24 2.24 5.29-5.29c.45-.45 1.17-.45 1.62 0s.45 1.17 0 1.62l-6.09 6.1c-.21.21-.5.33-.81.33Z"
      })
    })
  }));
};
CallingMadeIcon.displayName = 'CallingMadeIcon';